import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar'

@Component({
  selector: 'app-contact-type01',
  standalone: true,
  imports: [MatIconModule,FuseCardComponent, NgStyle,GoogleMapsModule, FormsModule, NgClass],
  templateUrl: './contact-type01.component.html',
  styleUrl: './contact-type01.component.scss'
})
export class ContactType01Component implements OnInit {

  public view: any = {
    title: 'Contact Us',
    defaultLat: -26.101691800405288,
    defaultLng :28.054557533604616,
    message: {}
  }

  constructor(public _tfmService: TFMService, private router: Router, private _cd: ChangeDetectorRef, private _snackBar: MatSnackBar) {

    this._tfmService.getContentBySection('contact').then(res => {
      this.view.page = res;
      console.log(res);
      this._tfmService.log(this.view);

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array
      
        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");
      
        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }
    });

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      // console.log(res);

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

    });
  }

  isFormValid() {
    let valid = true;
  
    if (!this.view.message.firstName || !this.view.message.lastName || !this.view.message.emailAddress)
      valid = false;
    return valid;
  };
  
  //Submit a message
  sendMessage() {
    this.view.message.isBusy = true;
    this.view.message.dateOfInquiry = new Date().toISOString();

    //create itinerary
    this._tfmService.createItin({'description': this.view.site.name + ' - Contact Us Form'}).subscribe(res => {
      localStorage.setItem(this._tfmService.itinIdentifier, res.content.itinerary.guid);
      this.view.itin = res;
      console.log(this.view.itin)

      this.view.itin.content.itinerary.firstName = this.view.message.firstName;
      this.view.itin.content.itinerary.lastName = this.view.message.lastName;
      this.view.itin.content.itinerary.emailAddress = this.view.message.emailAddress;
      this.view.itin.content.itinerary.phoneNumber = this.view.message.phoneNumber;

      //Send the Updated itinerary
      this._tfmService.filterAndSend(this.view.itin.content.itinerary._links, 'edit', this.view.itin.content.itinerary).subscribe(res => {
        let msg = {content: ''};
        msg.content += (this.view.message.comments || '') + '\n';

        //Create message
        this._tfmService.createMessage(msg).subscribe(res => {
          if(res == null) {
            this.view.message.status = 'Something went wrong' + ' ' + 'Your Reference number is: ' + ' ' + this.view.itin.content.itinerary.reference;
          }
          else {
            this.view.message.status = 'Message Sent Successfully' + ' ' + 'Your Reference number is: ' + ' ' + this.view.itin.content.itinerary.reference;
            this.showToast('Message sent successfully!', 'Close');
            //  contactForm.resetForm();
          }
          this.view.message.isBusy = false;
        });
      }); 
    });
  }

  showToast(message: string, action: string = 'Close', duration: number = 3000) {
    this._snackBar.open(message, action, {
      duration: duration
    });
  }
  ngOnInit(): void {
      
  }

}
